import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import * as Yup from 'yup';

import Textarea from '@components/Textarea/index';

import { Button } from './YourNotes.style';

const messages = defineMessages({
  addPlaceholder: {
    id: 'newNoteForm.addPlaceholder',
    defaultMessage: 'Add note here',
  },
  addNote: {
    id: 'newNoteForm.addNote',
    defaultMessage: 'ADD NOTE',
  },
  required: {
    id: 'GLOBAL.required',
    defaultMessage: 'This field is required',
  },
});

interface NewNoteFormProps {
  onSubmit: (noteText: string) => void;
}

export default function NewNoteForm({ onSubmit }: NewNoteFormProps) {
  const { formatMessage } = useIntl();
  const [noteText, setNoteText] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addNoteSchema = Yup.object().shape({
    noteText: Yup.string().required(formatMessage(messages.required)),
  });

  const handleSubmit = async () => {
    setError(null);

    try {
      await addNoteSchema.validate({ noteText }, { abortEarly: false });
      setIsSubmitting(true);
      onSubmit(noteText);
      setIsSubmitting(false);
      setNoteText('');
    } catch (validationError: any) {
      setError(validationError.errors?.[0] ?? 'Invalid value');
    }
  };

  return (
    <div>
      <Textarea
        value={noteText}
        onChange={(e) => (setNoteText(e.target.value), setError(null))}
        maxLength={4000}
        placeholder={formatMessage(messages.addPlaceholder)}
        required
        message={error || undefined}
      />
      <Button type="button" disabled={isSubmitting} onClick={handleSubmit}>
        {formatMessage(messages.addNote)}
      </Button>
    </div>
  );
}
